import { Component, Prop, Vue, Mixins} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import SheetFieldComponent from "Components/SheetCalculatur/SheetFieldComponent";
import MatProvider from "Components/SheetCalculatur/MatSheet/MatProvider"; 
import { ISheetProvider } from '../SheetProvider';
import ShoulderSinksProvider from './ShoulderSinkProvider';
import BaseComponent from 'Components/Base/ABaseComponent';

//TODO: add type to change between providers at initialize state
@Component({
    components: {
        SheetFieldComponent
    }
})
export default class SheetCalculatorShoulderSinkComponent extends mixins(BaseComponent, Vue) {
    
    
    @Prop()
    private constants: any;
    
    private provider: ISheetProvider = new ShoulderSinksProvider();
    
    private fields: any = {};
    
    
    created() {
        this.setLoading();
        this.fields = this.provider.getFields();
        
        console.debug('shoulder sink constants : ',this.constants);
        if(!!this.constants){
            for(var key in this.constants){
                this.provider.setValue(key, this.constants[key]);
            }
        }
        this.setLoaded();
    }
    
    
    onFieldChange(key: string, value: Number) {
        this.provider.setValue(key, value);
        
        for (var key in this.fields) {
            //console.log(key);
            this.fields[key].nextValue = this.fields[key].value();
        }
        
        //force update of all binded data in child components
        this.$forceUpdate();
    }
    
    getValue(key: string) {
        return this.provider.getValue(key);
    }
    
}



Vue.component('sheet-calculator-shouldersink', SheetCalculatorShoulderSinkComponent);



